export const LOAD_MARKDOWN_FROM_FILE = 'loadLearnsetFromFile';
export const LOAD_MARKDOWN_FROM_URL = 'loadLearnsetFromUrl';
export const ADD_LEARNSET_FROM_TOKENS = 'loadLearnsetFromTokens';
export const ADD_LEARNSET_FROM_MARKDOWN = 'loadLearnsetFromMarkdown';
